import React from 'react';
import Modal from 'react-responsive-modal';

interface AboutModalProps {
  open: boolean;
  onClose: () => void;
  version: string;
}

const ResponsiveModal = Modal as unknown as React.ComponentType<any>;

export const AboutModal: React.FC<AboutModalProps> = ({ open, onClose, version }) => {
  return (
    <ResponsiveModal
      open={open}
      onClose={onClose}
      center
      classNames={{
        modal: 'bg-white rounded-lg shadow-lg p-6 max-w-md mx-auto',
      }}
      closeIcon={<span>&times;</span>}
    >
      <div className="flex flex-col gap-4">
        <header>
          <h2 className="text-xl font-semibold text-gray-900">À propos d&apos;Expedinet</h2>
          <p className="text-sm text-gray-600">
            Gestion logistique Kewlox – application desktop Expedinet.
          </p>
        </header>
        <section className="text-sm text-gray-800">
          <p>
            Version de l’application&nbsp;:
            <span className="ml-2 font-mono text-base">{version || 'inconnue'}</span>
          </p>
        </section>
        <footer className="text-xs text-gray-500">
          © {new Date().getFullYear()} Kewlox. Tous droits réservés.
        </footer>
      </div>
    </ResponsiveModal>
  );
};

export default AboutModal;
